"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSkipButtonSelector = exports.defaultSkipCardSelector = exports.POST_FETCH_CONFIG = exports.SUMMARY_EVENT_REQUEST_URL = exports.LINK_AND_BUTTONS_EVENT_REQUEST_URL = exports.REQUEST_URL = exports.DEFAULT_CURRENCY_INTEGER_NUMBER_FORMAT = exports.DEFAULT_CURRENCY_DECIMAL_NUMBER_FORMAT = exports.DEBUG_LIST_CLASS = exports.SKIMLINKS_LINK_FRAGMENT = exports.DEBUG_QUERY = exports.DEBUG_ID = exports.FALLBACK_LOCALE = exports.UPDATE_DATA_KEY = exports.ALTERNATIVE_ATTRIBUTE = exports.REPLACED_ATTRIBUTE = exports.UPDATED_ATTRIBUTE = exports.PROCESSED_ATTRIBUTE = void 0;
exports.PROCESSED_ATTRIBUTE = "data-tbl-sl-processed";
exports.UPDATED_ATTRIBUTE = "data-tbl-sl-updated";
exports.REPLACED_ATTRIBUTE = "data-tbl-sl-replaced";
exports.ALTERNATIVE_ATTRIBUTE = "data-tbl-sl-alternative";
exports.UPDATE_DATA_KEY = "input_url";
exports.FALLBACK_LOCALE = "en-US";
exports.DEBUG_ID = "tbl-sl-debug";
exports.DEBUG_QUERY = "tblSlDebug=1";
exports.SKIMLINKS_LINK_FRAGMENT = "//go.skimresources.com";
exports.DEBUG_LIST_CLASS = "tbl-sl-debug-mode-merchant-list";
exports.DEFAULT_CURRENCY_DECIMAL_NUMBER_FORMAT = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
};
exports.DEFAULT_CURRENCY_INTEGER_NUMBER_FORMAT = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
};
exports.REQUEST_URL = {
    DOM: "https://t.skimresources.com/api/v2/generic_tracking/dynamic_button_dom",
    VISIBLE: "https://t.skimresources.com/api/v2/generic_tracking/dynamic_button_visible",
};
exports.LINK_AND_BUTTONS_EVENT_REQUEST_URL = "https://t.skimresources.com/api/v2/generic_tracking/dynamic_button_browser_events";
exports.SUMMARY_EVENT_REQUEST_URL = "https://t.skimresources.com/api/v2/generic_tracking/dynamic_buttons_summary";
exports.POST_FETCH_CONFIG = {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
    },
};
exports.defaultSkipCardSelector = ".noskimbutton";
exports.defaultSkipButtonSelector = ".noskim";
